
import importAllSvg from '@/lib/importAllSvg';
import {Component, Prop, Vue} from 'vue-property-decorator';

importAllSvg();

@Component
export default class Icon extends Vue {
  // 动态引入 svg name
  @Prop({default: ''}) ['name']: string;
}
